var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert-remind-thanks",class:{ show: _vm.isShow }},[_c('p',[_vm._v("Edit 'Thank You' step for 'Phone OTP' input field to ensure proper form function")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","small":""},on:{"click":function($event){_vm.isShow = false}}},[_vm._v("Got it")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }